<template>
  <div id="Dist" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 bg-color-white pl5 pr5 fixed-t b-s-2">
      <div class="col-12 lh40 bg-color-white pl5 pr5">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-muted"></i></div>
          <div class="col-6 t-c color-white">-</div>
          <div class="col-3 t-r f26"><i class="iconfont icon-gengduo color-muted"></i></div>
      </div>
      
      <div class="col-12 bg-color-white pl20 pr20 pb20">
        <div class="col-12 t-c">
          <img src="../../assets/user.png" alt="" class="w10 r50">
        </div>
        <div class="col-12 t-c pt10 fw f18 uppercase el1">
         <span class="color-muted fw100" v-if="$store.state.account_grade == 99">{{ pageData.account_id }}</span> {{ pageData.name }} <span class="bg-color-warning color-white f12 pt1 pb1 pl3 pr3 r5">L.{{pageData.account_grade}}</span>
        </div>
      </div>
    </div>
    <div class="h20"></div>
    <div class="col-12 pt5 pb5">
      <div class="col-12 bg-color-white">
        <div class="col-4 pr5 pt8 pb8">
          <div class="col-12 bg-color-white t-c r5 br1">
            <div class="col-12 f28 color-primary">{{pageData.account_points}}</div>
            <div class="col-12 f14 color-muted">Puntos</div>
          </div>
        </div>
        <div class="col-4 pl5 pr5 pt8 pb8">
          <div class="col-12 bg-color-white t-c r5 br1">
            <div class="col-12 f28 color-primary">{{pageData.lock_points}}</div>
            <div class="col-12 f14 color-muted">Bloqueado</div>
          </div>
        </div>
        <div class="col-4 pl5 pt8 pb8">
          <div class="col-12 bg-color-white t-c r5">
            <div class="col-12 f28 color-primary">{{pageData.account_credit}}</div>
            <div class="col-12 f14 color-muted">Crédito</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt5 t-c">
      <div class="col-12 bg-color-white pl10 pr10 lh50" @click="go_funds()">
        <div class="col-2 f30 t-l color-primary">
          <i class="iconfont icon-cunkuan"></i>
        </div>
        <div class="col-10 bb1">
          <div class="col-6 t-l ">Fondos</div>
          <div class="col-6 t-r"><i class="iconfont icon-31fanhui2 color-muted"></i></div>
        </div>
      </div>
      <div class="col-12 bg-color-white pl10 pr10 lh50" @click="go_clients_list()">
        <div class="col-2 f30 t-l color-primary">
          <i class="iconfont icon-31haoyou"></i>
        </div>
        <div class="col-10 bb1">
          <div class="col-6 t-l ">Clientes</div>
          <div class="col-6 t-r"><span class="mr10 fw">{{ pageData.client_count }}</span><i class="iconfont icon-31fanhui2 color-muted"></i></div>
        </div>
      </div>
      <div class="col-12 bg-color-white pl10 pr10 lh50" @click="go_dist_list()">
        <div class="col-2 f30 t-l color-primary">
          <i class="iconfont icon-jingxiaoshang"></i>
        </div>
        <div class="col-10 bb1">
          <div class="col-6 t-l ">Distribuidores</div>
          <div class="col-6 t-r"><span class="mr10 fw">{{ pageData.dist_count }}</span><i class="iconfont icon-31fanhui2 color-muted"></i></div>
        </div>
      </div>
      <div class="col-12 bg-color-white pl10 pr10 lh50">
        <div class="col-2 f30 t-l color-primary">
          <i class="iconfont icon-type-of-work-managem"></i>
        </div>
        <div class="col-10 bb1" @click="go_tec_list()">
          <div class="col-6 t-l ">Tecnicos</div>
          <div class="col-6 t-r"><span class="mr10 fw">{{ pageData.tec_count }}</span><i class="iconfont icon-31fanhui2 color-muted"></i></div>
        </div>
      </div>
      <div class="col-12 bg-color-white pl10 pr10 lh50" @click="go_report()">
        <div class="col-2 f30 t-l color-primary">
          <i class="iconfont icon-fl-baobiao"></i>
        </div>
        <div class="col-10 bb1">
          <div class="col-6 t-l ">Report</div>
          <div class="col-6 t-r"><i class="iconfont icon-31fanhui2 color-muted"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Dist',
  data () {
    return {
      aid: '',
      pageData: {}
    }
  },
  created: function () {
    this.aid = this.$route.query.aid;
    this.get_pageData();
  },
  methods: {
    get_pageData() {
      var post_data = {}
      post_data.aid = this.aid;
      this.post(this.api_url + 'Agent/dist',post_data,true).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      });
    },
    go_tec_list(){
      this.$router.push({name:'TecList',query:{aid: this.aid}});
    },
    go_funds(){
      this.$router.push({name:'A_Funds',query:{aid:this. aid}});
    },
    go_clients_list(){
      this.$router.push({name:'A_ClientsList',query:{aid: this.aid}});
    },
    go_dist_list(){
      this.$router.push({name:'DistList',query:{aid: this.aid}});
    },
    go_report(){
      this.$router.push({name:'A_Report',query:{aid: this.aid}});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Agent/Dist.vue